export default __webpack_public_path__ + "83fbec1de119e5a6db7d5075f4653e09.gif";